/**
 * THEME.JS
 * 
 * 1. retreive and parse all event data
 * 2. upcoming event panel (meganav)
 * 3. calendar widget (timetable page)
 * 4. booking app (product page)
 * 5. class details tabs (product page)
 * 6. dual slick.js slider tab switcher (homepage)
 * 7. sliders (product page)
 * 8. initalise modules
 */

// --------------------------------------------------------------------------
// 1. retreive and parse all event data
// --------------------------------------------------------------------------

var getEvents = (function () {

  var settings = {
    page: 1,
    product_offset: 50,
    events: [],
    now: moment(),
    mjsEvents: [],
    currentMjsEvents: []
  };

  var checkIfPageRefreshed = function(callback) {
    if(window.location.href == sessionStorage.getItem('origin')){
        sessionStorage.removeItem('ljsEvents');
        console.log('page refreshed');
    }
    else { 
      sessionStorage.setItem('origin', window.location.href);
      console.log('new page visited');
    }
    callback();
  }

  var checkCache = function(callback) {
    if (window.sessionStorage.getItem('ljsEvents') === null) {
      console.log('sessionStorage not set - attempting to set');
      beforeInit(function() {
        getJSON(function() {
          dateStringsToMomentObjects(function(){
            deleteOldEvents(function(){
              sortDatesInAscendingOrder(function(){
                afterInit(function(){
                  setCache(function() {
                    callback();
                  });
                });
              });
            });
          });
        });
      });
    } else {
      console.log('sessionStorage set - attempting to parse');
      getCache(function() {
        dateStringsToMomentObjects(function(){
          deleteOldEvents(function(){
            sortDatesInAscendingOrder(function(){
              callback();
            });
          });
        });
      });
    }
  }

  var setCache = function(callback) {
    var json = JSON.stringify(settings.events);
    window.sessionStorage.setItem('ljsEvents', json);
    callback();
  }

  var getCache = function (callback) {
    settings.events = JSON.parse(window.sessionStorage.getItem('ljsEvents'));
    document.querySelector('body').classList.toggle('unloaded');
    callback();
  }

  var revealElements = function (callback) {
    document.querySelector('body').classList.toggle('unloaded');
  }

  var beforeInit = function (callback) {
    document.querySelector('.lds-roller').classList.toggle('loading');
    document.querySelector('body').classList.add('transition');
    callback();
  }

  var afterInit = function (callback) {
    document.querySelector('body').classList.toggle('unloaded');
    document.querySelector('.lds-roller').classList.toggle('loading');
    callback();
  }

  var whichTransitionEvent = function () {
      var t;
      var el = document.querySelector('body');
      var transitions = {
        'transition':'transitionend',
        'OTransition':'oTransitionEnd',
        'MozTransition':'transitionend',
        'WebkitTransition':'webkitTransitionEnd'
      }

      for(t in transitions){
          if( el.style[t] !== undefined ){
              return transitions[t];
          }
      }
  }

  var transitionEnd = whichTransitionEvent();
  document.querySelector('main').addEventListener(transitionEnd, theFunctionToInvoke, false);

  var theFunctionToInvoke = function () {
    document.querySelector('body').classList.remove('transition');
  // set margin of div here
  }

  var getJSON = function (callback) {
    var finished = false;
    $.ajax({
      url:  '/collections/all-courses?page=' + settings.page,
      type: 'GET'
    })
    .done(function(data) {
      var productData = $.parseJSON(data);
      (settings.events.length < 1) ? settings.events = productData.products : settings.events = settings.events.concat(productData.products);
      if (productData.product_count > settings.product_offset) {
        settings.page++;
        settings.product_offset = settings.product_offset + 50;
        getJSON(callback);
      } else {
        finished = true;
      }
      finished ? callback() : '';
    })
    .fail(function(data) {})
    .always(function(data) {});
  }

  var dateStringsToMomentObjects = function (callback) {
    for (var i=0; i<settings.events.length; i++) {
      var event = settings.events[i];
      var day = event._day;
      var start = event.start;
      var end = event.end;
      var startDate = day + ' ' + start;
      var endDate = day + ' ' + end;
      event.start = moment(startDate, 'DD-MM-YYYY HHmm');
      event.end = moment(endDate, 'DD-MM-YYYY HHmm');
      settings.mjsEvents.push(event);
    }
    callback();
  };

  var deleteOldEvents = function (callback) {
    for (var i=0; i<settings.mjsEvents.length; i++) {
      var event = settings.mjsEvents[i];
      var date = event.start;
      if ( date.isAfter(settings.now) ) {
        settings.currentMjsEvents.push(event);
      }
    }
    callback();
  };

  var sortDatesInAscendingOrder = function (callback) {
    function compare(a,b) {
      if ( moment(a.start).isBefore(b.start) )
        return -1;
      if ( moment(a.start).isAfter(b.start) )
        return 1;
      return 0;
    }
    settings.currentMjsEvents.sort(compare);
    callback();
  };

  return {
    init: function (callback) {
      checkIfPageRefreshed(function() {
        checkCache(callback)
      });
    },
    getFirstEvent: function () {
      return settings.currentMjsEvents[0];
    },
    now: settings.now,
    getCurrentEvents: function () {
      return settings.currentMjsEvents;
    }
  }

})();

// --------------------------------------------------------------------------
// 2. upcoming event panel (meganav)
// --------------------------------------------------------------------------

var getNextEvent = (function (next) {

    var settings = { 
      upcomingEvent: '',
      upcomingClassTitle: document.querySelectorAll('.upcoming-class-title'),
      upcomingClassUrl: document.querySelectorAll('.upcoming-class-link'),
      upcomingClassImage: document.querySelectorAll('.upcoming-class-image')
    };

    var setNextEventTitles = function() {
      for (var i=0; i<settings.upcomingClassTitle.length; i++) {
        settings.upcomingClassTitle[i].textContent = settings.upcomingEvent.title;
      }
    };

    var setNextEventLinks = function() {
      for (var i=0; i<settings.upcomingClassImage.length; i++) {
        if (settings.upcomingClassImage[i].dataset.userImage === undefined) {
          settings.upcomingClassImage[i].style.backgroundImage = 'url(' + settings.upcomingEvent._image + ')';
        }
      }
    };

    var setNextEventImages = function() {
      for (var i=0; i<settings.upcomingClassUrl.length; i++) {
        settings.upcomingClassUrl[i].href = settings.upcomingEvent.url;
      }
    };

    return {
      init: function(next) {
        settings.upcomingEvent = next;
        setNextEventTitles();
        setNextEventLinks();
        setNextEventImages();
      }
    }

})();

// --------------------------------------------------------------------------
// 3. calendar widget (timetable page)
// --------------------------------------------------------------------------

var calendarWidget = (function(){

  var settings = {
    calendarEvents: document.getElementsByClassName('calendar-event'),
    $calendar: $('#calendar'),
    limitTextFunction: function(){ return 'SEE ALL' },
    firstOfThisMonth: moment(getEvents.now).date(1),
    oneYearFromNow: moment(getEvents.now).add(1, 'year'),
    viewCompact: (window.innerWidth < 768) ? true : false,
    initialView: (window.innerWidth < 768) ? 'listMonth' : 'month',
    initalAspectRatio: (window.innerWidth < 768) ? 0.75 : 2,
    currentLimits: (window.innerWidth < 768) ? 'lower' : 'upper'
  };

  var watchWindow = function() {
    window.addEventListener('resize', function(event){
      respondToWindowWidth(settings);
    });
  };

  var respondToWindowWidth = function() {
    var windowWidth = window.innerWidth;
    if ( settings.currentLimits === 'lower' ) {
      if ( windowWidth > 767 ) {
        changeCalendarView();
        settings.currentLimits = 'upper';
      }

    }
    if ( settings.currentLimits === 'upper' ) {  
      if ( windowWidth < 768 ) {
        changeCalendarView();
        settings.currentLimits = 'lower';
      }
    }
  };

  var changeCalendarView = function() {
    !settings.viewCompact ? compactCalendarSettings() : wideCalendarSettings();
    settings.viewCompact = !settings.viewCompact;
  };

  var compactCalendarSettings = function() {
    settings.$calendar.fullCalendar('changeView', 'listMonth');
    settings.$calendar.fullCalendar('option', {
      aspectRatio: 0.75
    });
  };

  var wideCalendarSettings = function() {
    settings.$calendar.fullCalendar('changeView', 'month');
    settings.$calendar.fullCalendar('option', {
      aspectRatio: 2
    });
  };

  var initCalendar = function() {
    settings.$calendar.fullCalendar({
      header: {
        left: 'prev',
        center: 'title',
        right: 'next'
      },
      defaultView: settings.initialView,
      validRange: {
        start: settings.firstOfThisMonth,
        end: settings.oneYearFromNow
      },
      firstDay: 1,
      events: getEvents.getCurrentEvents(), //TODO
      displayEventTime: false,
      eventBorderColor: 'transparent',
      eventColor: 'transparent',
      eventLimit: 3,
      eventLimitText: settings.limitTextFunction,
      fixedWeekCount: false,
      showNonCurrentDates: false,
      columnHeaderFormat: 'dddd',
      eventAfterAllRender: calendarWidget.watchWindow,
      weekMode: 'liquid'
    });
  };

  return {
    init: function() {
      watchWindow();
      initCalendar();
    }
  }

})();

// --------------------------------------------------------------------------
// 4. booking app (product page)
// --------------------------------------------------------------------------

var bookingApp = (function(currentEvents, now) {

  //console.log(currentEvents);

  var config = {
    optionTags: document.querySelectorAll('.product-form-nojs-variants-select option:not([disabled])'),
    atcBtn: document.querySelector('.product-form-nojs-atc-button'),
    warning: document.querySelector('.selection-warning-message'),
    optionId: '',
    pikaDateArray: [],
    firstSelectionMade: false,
  };

  var getCourseDates = function(currentEvents, callback){
    for (var i=0; i<currentEvents.length; i++) {
      var event = currentEvents[i];
      if ( event.title === document.querySelector('.product-core h2').textContent ) {
        var momentString = moment(event.start).format("DD-MM-YYYY");
        config.pikaDateArray.push(momentString);
      }
    }
    addPikaConfigs(callback);
  };

  var addPikaConfigs = function(callback) {
    config.startOfMonth = moment(config.pikaDateArray[0], "DD-MM-YYYY").startOf('month');
    config.endOfMonth = moment(config.pikaDateArray[0], "DD-MM-YYYY").endOf('month');
    config.oneYearOn = moment(config.endOfMonth).add(1, 'y');
    config.startYear = moment(now).year();
    config.endYear = moment(config.oneYearOn).year();
    callback();
  };

  var initialisePikaday = function() {
    new Pikaday(
    {
      field: document.getElementById('datepicker'),
      bound: false,
      container: document.getElementById('pikaday-container'),
      defaultDate: moment(config.startOfMonth).toDate(),
      minDate: moment(config.startOfMonth).toDate(),
      maxDate: moment(config.oneYearOn).toDate(),
      yearRange: [config.startYear,config.endYear],
      disableDayFn: function(date) {
        if ($.inArray(moment(date).format("DD-MM-YYYY"), config.pikaDateArray) === -1) {
            return date;
        }
      },
      format: 'DD-MM-YYYY',
      showDaysInNextAndPreviousMonths: true,
      firstDay: 1,
      onSelect: function(date) {
        if (config.firstSelectionMade === false) { config.firstSelectionMade = true }
        if (config.warning.classList.contains('show')) { config.warning.classList.remove('show') }
        selectDate = moment(date).format("DD-MM-YYYY");
        for (var i = 0; i < config.optionTags.length; i++) {
          var optionDate = config.optionTags[i].textContent.replace(/\s/g, '');
          if (optionDate == selectDate) {
            config.optionId = config.optionTags[i].value;
            break;
          }
        }
        document.querySelector('.product-form-nojs-variants-select').value = config.optionId;
      }
    });
  };

  var initialiseModal = function() {
    MicroModal.init({
      //onShow: modal => console.info(`${modal.id} is shown`), // [1]
      //onClose: modal => console.info(`${modal.id} is hidden`), // [2]
      openTrigger: 'data-custom-open', // [3]
      closeTrigger: 'data-custom-close', // [4]
      disableScroll: false, // [5]
      disableFocus: false, // [6]
      awaitCloseAnimation: false, // [7]
      debugMode: true // [8]
    });
  };

  var onAddToCart = function() {
    console.log('atcBtn event listener bound');
    var atcBtn = config.atcBtn;
    atcBtn.addEventListener('click', function(e) {
      e.preventDefault(); 
      if (config.firstSelectionMade === false) {
        config.warning.classList.add('show');
        //$(this).css("background-color", "yellow");
      } else {
        $.post('/cart/add.js', {
          quantity: 1,
          id: config.optionId
        }).done(function() {
          window.location.href = '/cart';
        }).fail(function(xhr, status, error) {
          //console.log("Ajax failed"); @aaliyan Gul 2020
          $('.pika-single .pika-lendar .pika-table tbody .pika-row td.is-selected .pika-button').css({'background-color': '#ffb1b1', 'border': '2px solid #ffb1b1'}).attr('disabled', 'disabled');
          $('.selection-warning-message').text('Selected Class is Full').addClass('show');
        });
      }
    });
  };

  return {
    init: function(currentEvents) {
      initialiseModal();
      getCourseDates(currentEvents, function() {
        initialisePikaday();
      });
      onAddToCart();
    }
  };

})();

// --------------------------------------------------------------------------
// 5. class details tabs (product page)
// --------------------------------------------------------------------------

var classDetailsTabs = (function() {

  var config = {
    switches: document.querySelectorAll('.product-details-nav [data-tab]'),
    reviewButton: document.querySelector('.btn.standard[data-tab="reviews"]'),
    tabs: document.querySelectorAll('.content [data-tab]')
  };

  var bindTabButtonActions = function() {
    for (var i=0; i<config.switches.length; i++) {
      config.switches[i].addEventListener('click', function() { switchTabs(this); });
      console.log('bindTabButtonActions');
    }
  };

  var bindReviewButtonAction = function() {
    if (config.reviewButton) {
      config.reviewButton.addEventListener('click', function() { switchTabs(this); });
        console.log('bindReviewButtonAction');
    }
  };

  var switchTabs = function(element) {

    var thisAttribute = element.dataset.tab;
    var targetTab, otherTab;
    
    var toggleSwitchClasses = function() {
      for (var i=0; i<config.switches.length; i++) {
        if ( config.switches[i].dataset.tab === thisAttribute ) config.switches[i].classList.add('active');
        if ( config.switches[i].dataset.tab !== thisAttribute ) config.switches[i].classList.remove('active');
      }
    };

    var selectTargetTab = function() {
      for (var i=0; i<config.tabs.length; i++) {
        if ( config.tabs[i].dataset.tab === thisAttribute ) targetTab = config.tabs[i];
        if ( config.tabs[i].dataset.tab !== thisAttribute ) otherTab = config.tabs[i];
      }
    };

    var changeTabVisibility = function() {
      targetTab.style.display = 'block';
      otherTab.style.display = 'none';
      if ( targetTab.querySelector('.review-slider') ) {
        $('.review-slider').slick('refresh');
      }
    };

    toggleSwitchClasses();
    selectTargetTab();
    changeTabVisibility();

  };

  var initialiseSlider = function() {
    $('.review-slider').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: false,
      //adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('a.reviewPrev').click(function(){
      $('.review-slider').slick('slickPrev');
    });
    $('a.reviewNext').click(function(){
      $('.review-slider').slick('slickNext');
    });
  };

  return {
    init: function() {
      bindTabButtonActions();
      bindReviewButtonAction();
      initialiseSlider();
    }
  };

})();

// --------------------------------------------------------------------------
// 6. dual slick.js slider tab switcher (homepage)
// --------------------------------------------------------------------------

var dualSliderTabSwitcher = (function() {

  var config = {
     $slider: $('.featured-classes'),
     sliders: document.querySelectorAll('.featured-classes'),
     sliderContainer: document.querySelector('.slider-container'),
     $sliderContainer: $('.slider-container'),
     sliderSwitches: document.querySelectorAll('.featured-classes-nav>li'),
     $activeSlider: $('.featured-classes').filter('.active'),
     $inactiveSlider: $('.featured-classes').not('.active'),
     switchStatus: true,
     sliderHeight: '',
     firstRun: true,
     slickSettings: {
                      infinite: true,
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      arrows: false,
                      responsive: [
                        {
                          breakpoint: 991,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                          }
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                          }
                        },
                        {
                          breakpoint: 480,
                          settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                          }
                        }
                      ]
                    }
  };

  var onSwitchClick = function() {
    if ( config.switchStatus === true ) {
      config.switchStatus = false;
      config.slickHeight = document.querySelector('.slick-slider').offsetHeight + 'px';
      config.sliderContainer.addEventListener("transitionend", function(event) {
        if ( config.sliderContainer.style.opacity == 0 ) {
          unslickThenSlick();
        }
      }, false);

      config.sliderContainer.style.height = config.slickHeight;
      config.sliderContainer.style.opacity = '0';
    }
  };

  var unslickThenSlick = function() {
    config.$activeSlider = config.$slider.filter('.active');
    config.$inactiveSlider = config.$slider.not('.active');
    config.$activeSlider.slick('unslick').css('display', 'none');
    config.$inactiveSlider.css('display', 'block');
    config.$slider.not('.active').slick(config.slickSettings);
  };

  var onSlickInit = function() {
    if (config.firstRun === false) {
    config.$sliderContainer.css({
     'height' : '',
     'opacity' : '1'
    });
    config.$inactiveSlider.addClass('was-inactive');
    config.$activeSlider.removeClass('active');
    config.$inactiveSlider.addClass('active').removeClass('was-inactive');
    document.querySelector('.featured-classes-nav>li:not(.active)').classList.add('was-inactive');
    document.querySelector('.featured-classes-nav>li.active').classList.remove('active');
    document.querySelector('.featured-classes-nav>li.was-inactive').classList.add('active');
    document.querySelector('.featured-classes-nav>li.active').classList.remove('was-inactive');
    config.switchStatus = true;
    } else {
      config.firstRun = false;
    }
  };

  var fadeInFirstSlide = function() {
    var $firstSlide = config.$slider.find('[data-slick-index="1"]');
    $firstSlide.addClass('fadein');
  };

  var initialiseSliders = function() {
    config.$slider.on('init', function(event, slick) {
      onSlickInit();
      fadeInFirstSlide();
    });
    config.$slider.filter('.active').slick(config.slickSettings);
    $('a.prev').click(function(){
      $('.slick-slider').slick('slickPrev');
    });
    $('a.next').click(function(){
      $('.slick-slider').slick('slickNext');
    });
    for (var i=0; i<config.sliderSwitches.length; i++) {
      config.sliderSwitches[i].addEventListener('click', onSwitchClick, false);
    }
    config.$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var $nextSlide = config.$slider.find('[data-slick-index="' + nextSlide + '"]');
      var $currentSlide = config.$slider.find('[data-slick-index="' + currentSlide + '"]');
      $currentSlide.next().removeClass('fadein');
      $nextSlide.next().addClass('fadein');
    });
  };

  return {
    init: function() {
      initialiseSliders();
    }
  };

})();

// --------------------------------------------------------------------------
// 7. sliders (product page)
// --------------------------------------------------------------------------

var courseImageSliders = (function() {

  $('.full-size-image').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.slider'
  });

  $('.vertical-slider .slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.full-size-image',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: true,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: true,
        }
      },
      {
        breakpoint: 991,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
        }
      }
    ],
    prevArrow: '',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="9" viewBox="0 0 17 9"><defs><path id="tlfta" d="M186.014 983.824a.577.577 0 0 1-.42.176.577.577 0 0 1-.42-.176.606.606 0 0 1 0-.85l7.391-7.474-7.391-7.474a.606.606 0 0 1 0-.85.59.59 0 0 1 .84 0l7.812 7.899a.606.606 0 0 1 0 .85l-7.812 7.9z"/></defs><g><g transform="translate(-181 -971)"><use fill="#1a1919" xlink:href="#tlfta"/></g></g></svg></button>'
  }); 

  $('.horizontal-slider .slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.full-size-image',
    prevArrow: '',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="9" viewBox="0 0 17 9"><defs><path id="tlfta" d="M186.014 983.824a.577.577 0 0 1-.42.176.577.577 0 0 1-.42-.176.606.606 0 0 1 0-.85l7.391-7.474-7.391-7.474a.606.606 0 0 1 0-.85.59.59 0 0 1 .84 0l7.812 7.899a.606.606 0 0 1 0 .85l-7.812 7.9z"/></defs><g><g transform="translate(-181 -971)"><use fill="#1a1919" xlink:href="#tlfta"/></g></g></svg></button>'
  });

  $(".horizontal-slider .slick-slide").click(function(e){
      e.preventDefault();
      slideIndex = this.dataset.slickIndex;
      $('.full-size-image').slick('slickGoTo', parseInt(slideIndex), false);
  });

  $(".vertical-slider .slick-slide").click(function(e){
      e.preventDefault();
      slideIndex = this.dataset.slickIndex;
      $('.full-size-image').slick('slickGoTo', parseInt(slideIndex), false);
  });

  return {
    init: function() {
      courseImageSliders();
    }
  };

})();

// --------------------------------------------------------------------------
// 8. organise navigation items
// --------------------------------------------------------------------------

var alignMenuItems = (function() {

  var config = {
    siteNavigation: document.querySelector('.site-navigation'),
    menu: document.querySelector('.site-navigation>ul'),
    menuItems: document.querySelectorAll('.site-navigation>ul>.navmenu-item'),
    logoItem: document.querySelector('.site-navigation>ul>.show-for-lg'),
    siteActionsItem: document.querySelector('.site-navigation>ul>.site-actions-item')
  };

  var moveSlides = function() {

    var leftAmount;
    var rightAmount;

    var leftWrapper = document.createElement('ul');
    leftWrapper.classList.add('navmenu','navmenu-depth-1','left-wrapper');
    var rightWrapper = document.createElement('ul');
    rightWrapper.classList.add('navmenu','navmenu-depth-1','right-wrapper');
    var siteActionsWrapper = document.createElement('ul');
    siteActionsWrapper.classList.add('navmenu','navmenu-depth-1','site-actions-wrapper');
    var logoWrapper = document.createElement('ul');
    logoWrapper.classList.add('navmenu','navmenu-depth-1','logo-wrapper');

    config.siteNavigation.appendChild(leftWrapper);
    config.siteNavigation.appendChild(logoWrapper);
    config.siteNavigation.appendChild(rightWrapper);
    config.siteNavigation.appendChild(siteActionsWrapper);

    var itemAmount = config.menuItems.length;

    if (itemAmount % 2 === 0) { 
      leftAmount = rightAmount = (itemAmount / 2);
    } else {
      leftAmount = Math.ceiling(itemAmount / 2);
      rightAmount = Math.floor(itemAmount / 2);
    } 

    for (var i = 0; i < config.menuItems.length; i++) {
      var menuItem = config.menuItems[i];
      if (i <= leftAmount) {
        leftWrapper.appendChild(menuItem);
      } else {
        rightWrapper.appendChild(menuItem);
      }
    }

    logoWrapper.appendChild(config.logoItem);
    siteActionsWrapper.appendChild(config.siteActionsItem);
    document.querySelector('.site-navigation ul').remove();
    config.siteNavigation.style.visibility = 'visible';
  };

  return {
    init: function() {
      moveSlides();
    }
  };

})();

// --------------------------------------------------------------------------
// 9. initalise
// --------------------------------------------------------------------------

var variantSelector = (function() {

  var config = {
    options: document.querySelectorAll('.option-value-input'),
    selections: document.querySelector('.variant-form select'),
    prevSelection: ''
  };

  var bindUiActions = function() {
    console.log('function initiated');
    for (var i = 0; i < config.options.length; i++) {
      console.log(i);
      var option = config.options[i];
      option.addEventListener('click', function(e) {
        console.log('variant clicked');
        select(e);
      });
    }
  }

  var select = function(el) {
    var target = el.target;
    config.prevSelection ? config.selections.querySelector('[value="' + config.prevSelection.value + '"]').removeAttribute('selected') : '';
    config.selections.querySelector('[value="' + target.value + '"]').setAttribute('selected', 'selected');
    config.prevSelection = target;
  }

  return {
    init: function() {
      bindUiActions();
    }
  };

})();

// --------------------------------------------------------------------------
// 10. initalise modules
// --------------------------------------------------------------------------

(function(){

  var themeEditor = document.querySelector('.in-theme-editor');
  var timetable = document.querySelector('.page.timetable');
  var giftcardPage = document.querySelector('.page-template-gift-card');
  var productPage = document.querySelector('.page-template-product');
  var bookingAppElem = document.querySelector('[data-booking-app]');
  var index = document.querySelector('.page-template-index');
  var variantForm = document.querySelector('[data-variant-form]');
  if (productPage) {
    var imageCount = document.querySelector('.full-size-image').dataset.imageCount;
    var productPageImageLimit = (imageCount < 3) ? true : false;
  }

  getEvents.init(function() {
    //modules that require event data go here...
    getNextEvent.init(getEvents.getFirstEvent());
    timetable ? calendarWidget.init() : '';
    (productPage && bookingAppElem) ? bookingApp.init( getEvents.getCurrentEvents(), getEvents.now ) : '';
  });

  if (giftcardPage || themeEditor) {
    document.querySelector('body').classList.toggle('unloaded');
    document.querySelector('.lds-roller').classList.toggle('loading');
  }

  if (index) { 
    dualSliderTabSwitcher.init();
  }
  productPage ? classDetailsTabs.init() : '';
  (productPage && !productPageImageLimit) ? courseImageSliders.init() : '';
  alignMenuItems.init();
  variantSelector.init();
})();